import config from '../config';

/**
 * Construit l'URL complète d'une image à partir de son chemin
 * @param {string} imagePath - Chemin de l'image (relatif ou absolu)
 * @returns {string} URL complète de l'image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return config.placeholderImage;

  // Si l'URL commence déjà par http, l'utiliser telle quelle
  if (imagePath.startsWith('http')) return imagePath;

  // Si le chemin commence déjà par storage/, ne pas le dupliquer
  if (imagePath.startsWith('storage/')) {
    return `${config.imageBaseUrl}/${imagePath}`;
  }

  // Construire l'URL complète avec le chemin de stockage
  return `${config.imageBaseUrl}/storage/${imagePath}`;
};

/**
 * Obtient l'URL d'une image de produit en priorisant image_url puis image_path
 * @param {Object} imageObject - Objet image avec image_url et/ou image_path
 * @returns {string} URL complète de l'image
 */
export const getProductImageUrl = (imageObject) => {
  if (!imageObject) return config.placeholderImage;

  // Priorité 1: image_url (URL complète depuis le backend)
  if (imageObject.image_url) {
    return imageObject.image_url;
  }

  // Priorité 2: image_path (chemin relatif à construire)
  if (imageObject.image_path) {
    return getImageUrl(imageObject.image_path);
  }

  return config.placeholderImage;
};

export default getImageUrl;

